<script lang="ts" setup>
import { ElMessage } from 'element-plus'
import { Clipboard } from 'v-clipboard'
// import { useSlots } from 'vue'
import Copy from 'components/copy/index.vue'
import type { Option } from '@/types/global'

const props = defineProps<{
  list: Option[],
  hiddenCopyAll?: boolean,
}>()

async function handleCopy() {
  const copyStr = props.list.map(item => `${item.label}${item.value}`).join('\n')
  try {
    await Clipboard.copy(copyStr)
    ElMessage.success('复制成功')
  } catch (error) {
    ElMessage.error('复制失败，请重试')
  }
}
</script>

<template>
  <div class="copy-box">
    <slot v-if="$slots.default" />
    <el-form label-width="90px">
      <el-form-item v-for="(item, index) in list" :key="index" :label="item.label">
        <el-input :model-value="item.value" disabled />
        <copy :content="item.value" class="copy-box-btn" />
      </el-form-item>
    </el-form>
    <div class="copy-box-footer">
      <el-button v-if="!hiddenCopyAll" type="primary" link @click="handleCopy">
        一键复制全部
      </el-button>
    </div>
    <!-- <div v-if="$slots.footer" class="copy-box-footer">
      一键复制全部
      <slot name="footer" />
    </div> -->
  </div>
</template>

<style lang="scss">
.copy-box {
  .el-form-item__content {
    .el-input {
      flex: 1;
    }

    .copy-box-btn {
      margin-left: 10px;
    }
  }

  .copy-box-footer {
    margin: 20px 0 0;
    text-align: right;
    .el-button {
      &:focus {
        color: #4b88ff;
      }
    }
  }
}

.message-box__credentials {
  width: 520px;
  max-width: 520px;

  .content {
    margin-bottom: 20px;
    line-height: 24px;
  }

  .el-form {
    .el-form-item {
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}

</style>
